import type { SelectionOptionsStatusUpdateRequest } from "@btnet/services-btnet/handlers/models/selectionOptionsStatusUpdateRequest";
import type { SelectionOptionsStatusUpdateResponse } from "@btnet/services-btnet/handlers/models/selectionOptionsStatusUpdateResponse";

import { showApixErrorMessage } from "utilities/api/apix-handler";
import { formattedPlural } from "utilities/string/string";

import { handleSelectionOptionActionMessages } from "entity/selectionOption/common/SelectionOption.utils";

export async function ResetSelectionOptions(
    builderId: number,
    jobId: number,
    selectionOptionIds: number[],
    selectionOptionTitle: string,
    resetOption: (params: {
        data: SelectionOptionsStatusUpdateRequest;
    }) => Promise<{ data: SelectionOptionsStatusUpdateResponse }>,
): Promise<boolean> {
    try {
        const response = await resetOption({
            data: {
                builderId,
                jobId,
                selectionOptionIds,
            },
        });

        // Handle success/failure messages
        const failedCount = Object.keys(response.data.failedSelectionOptions ?? {}).length;
        const successCount = selectionOptionIds.length - failedCount;

        handleSelectionOptionActionMessages(
            "reset",
            selectionOptionTitle,
            successCount,
            failedCount,
            selectionOptionIds,
        );

        return failedCount === 0;
    } catch (e) {
        const optionLabel = formattedPlural({
            value: selectionOptionIds.length,
            one: "Selection option",
            other: "Selection options",
        });
        showApixErrorMessage(e as Error, `${optionLabel} could not be recalled`);
        return false;
    }
}
